// Locale display names
export function getLocaleDisplayName(locale: string): string {
  const names: Record<string, string> = {
    bs: 'Bosanski',
    en: 'English',
    tr: 'Turkce',
  };
  return names[locale] || locale;
}

// Flag image URLs from flagsapi.com
export function getLocaleFlagUrl(locale: string): string {
  const countryCodes: Record<string, string> = {
    bs: 'BA',
    en: 'GB',
    tr: 'TR',
  };
  const code = countryCodes[locale] || 'GB';
  return `https://flagsapi.com/${code}/flat/64.png`;
}
